import { prefixPublic } from "./namespacePrefixes";

const publicUrlBase = prefixPublic('recaptcha');

export const RecaptchaEndpoints = {
  public: {
    verify: `${publicUrlBase}/validate`,
  },
}